module.exports = __webpack_public_path__ + "img/img-gallery-3.c6744c4f.jpg";